import React, { useState } from 'react';
import whatsapp from "../assets/whatsapp.png";

export default function Contact() {
  const [form, setForm] = useState({ name: '', adresse: '', message: '' });
  const [sent, setSent] = useState(false);

  function handleChange(e) {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  }

  function handleSubmit(e) {
    e.preventDefault();

    // Construire le message WhatsApp
    const message = `Nom: ${form.name}\nAdresse: ${form.adresse}\nMessage: ${form.message}`;

    // Numéro WhatsApp (sans + ni espaces)
    const phoneNumber = "213560046028";

    // Créer le lien WhatsApp
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    // Ouvrir WhatsApp dans un nouvel onglet / application
    window.open(url, "_blank");

    // Afficher le message de succès
    setSent(true);
    setForm({ name: '', adresse: '', message: '' });
    setTimeout(() => setSent(false), 4000);
  }

  return (
    <section id="contact" className="contact container">
      <img src={whatsapp} alt="WhatsApp" />
      <h2>Contactez-nous</h2>
      <div className="contact-grid">
        <form onSubmit={handleSubmit} className="contact-form">
          <input
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Nom"
            required
          />
          <input
            name="adresse"
            value={form.adresse}
            onChange={handleChange}
            placeholder="Adresse"
          />
          <textarea
            name="message"
            value={form.message}
            onChange={handleChange}
            placeholder="Détails du chantier"
            rows="5"
            required
          />
          <button className="btn-primary" type="submit">
            Envoyer
          </button>
          {sent && <div className="success">Merci — votre demande a été envoyée !</div>}
        </form>

        <div className="contact-info">
          <h3>Infos</h3>
          <p>
            📍 Adresse: <strong>37 Traverse de la Michèle, 13015 Marseille</strong>
          </p>
          <p>
            📞 Téléphone:{" "}
            <strong>
              <a href="tel:+33609840239">06 09 84 02 39</a>
            </strong>
            <br />
            <strong>
              <a href="tel:+33612425201">06 12 42 52 01</a>
            </strong>
          </p>
          <p>
            📧 Email:{" "}
            <strong>
              <a href="mailto:ms.multiservicepro@gmail.com">ms.multiservicepro@gmail.com</a>
            </strong>
          </p>
          <p>SIRET: <strong>932 814 817</strong></p>
          <p>Disponible 7j/7 24h/24</p>
        </div>
      </div>
    </section>
  );
}
